import { type ChangeEvent, type FormEvent, useState } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { useRouterLinkClick } from '../../../hooks/useRouterLinkClick';

const FORGOT_PASSWORD_PATH = '/forgot-password';

export function useLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { signIn, user } = useAuth();
  const handleForgotPasswordClick = useRouterLinkClick(FORGOT_PASSWORD_PATH);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!email.trim() || !password) {
      setError('Renseignez votre adresse email et votre mot de passe.');
      return;
    }

    setError(null);
    setIsSubmitting(true);
    try {
      await signIn(email, password);
    } catch (err) {
      console.error('Auth error:', err);
      setError('Erreur de connexion. Vérifiez vos identifiants puis réessayez.');
    } finally {
      setIsSubmitting(false);
    }
  }

  function handleEmailChange(event: ChangeEvent<HTMLInputElement>) {
    setEmail(event.target.value);
  }

  function handlePasswordChange(event: ChangeEvent<HTMLInputElement>) {
    setPassword(event.target.value);
  }

  function handleTogglePassword() {
    setShowPassword((show) => !show);
  }

  return {
    user,
    email,
    password,
    error,
    showPassword,
    isSubmitting,
    handleSubmit,
    handleEmailChange,
    handlePasswordChange,
    handleTogglePassword,
    handleForgotPasswordClick,
  };
}
